import React from "react";
import { FadeLoader } from "react-spinners";
import "./spinner.css";

export default function Spinner() {
  return (
    <div className="loader_container">
      <FadeLoader size={80} color="var(--orange-color)" />
    </div>
  );
}
